import React, { useState, useEffect } from 'react';
import UserMenu from './UserMenu';
import { useTheme } from '../context/ThemeContext';
import BottomNav from './BottomNav';
import SidebarNav from './SidebarNav';
import useIsMobile from '../hooks/useIsMobile';
import useFavicon from '../hooks/useFavicon';
import { getSettings } from '../utils/settingsCache';
import { OfflineModeBanner } from './OfflineBanner';

export default function MusicianLayout({ children, title, scrollable = true }) {
  const theme = useTheme();
  const isMobile = useIsMobile(900);
  const [bandName, setBandName] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    getSettings()
      .then(data => {
        setBandName(data?.band_name || '');
        setLogoUrl(data?.logo_url || '');
      })
      .catch(() => {});
  }, []);

  useFavicon(logoUrl);

  if (!isMobile) {
    return (
      <div style={{
        display: 'flex',
        height: '100dvh',
        background: theme.background,
        overflow: 'hidden',
      }}>
        <SidebarNav bandName={bandName} logoUrl={logoUrl} />

        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          {title && (
            <div style={{
              flexShrink: 0,
              background: theme.navGradient,
            }}>
              <div style={{ padding: '12px 24px 16px' }}>
                <div style={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: '#fff',
                  lineHeight: 1.2,
                }}>
                  {title}
                </div>
              </div>
            </div>
          )}

          <OfflineModeBanner />
          <div style={{
            flex: 1,
            minHeight: 0,
            overflowY: scrollable ? 'auto' : 'hidden',
            WebkitOverflowScrolling: 'touch',
          }}>
            {children}
          </div>
        </div>
      </div>
    );
  }

  // Pinned to the screen edges rather than sized with 100dvh: installed (home-screen) Android
  // Chrome can size dvh for browser bars that aren't there, pushing the bottom nav off screen
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      inset: 0,
      background: theme.background,
      overflow: 'hidden',
    }}>
      {title && (
        <div style={{
          flexShrink: 0,
          background: theme.navGradient,
          padding: 'env(safe-area-inset-top) 0 0',
        }}>
          <div style={{ padding: '10px 16px 14px', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
            <div>
              {bandName && (
                <div style={{
                  fontSize: 11,
                  fontFamily: 'monospace',
                  color: 'rgba(255,255,255,0.7)',
                  letterSpacing: '0.08em',
                  marginBottom: 2,
                }}>
                  {bandName.toUpperCase()}
                </div>
              )}
              <div style={{
                fontSize: 22,
                fontWeight: 700,
                color: '#fff',
                lineHeight: 1.2,
              }}>
                {title}
              </div>
            </div>
            <UserMenu placement="down" />
          </div>
        </div>
      )}

      <OfflineModeBanner />
      <div style={{
        flex: 1,
        minHeight: 0,
        overflowY: scrollable ? 'auto' : 'hidden',
        WebkitOverflowScrolling: 'touch',
      }}>
        {children}
      </div>

      <BottomNav />
    </div>
  );
}
